var map = {
	"./01-Sakura.jpg": 503,
	"./02-Sakura Red.jpg": 351,
	"./03-Frame On The Way To OOTY.JPG": 469,
	"./Ace.jpg": 759,
	"./Actually Chennai.jpg": 883,
	"./Beeeeeeeee.jpg": 871,
	"./Bugss.jpg": 914,
	"./Green Sky.jpg": 576,
	"./In Sunlight.jpg": 303,
	"./Niceeee.jpg": 84,
	"./Old One.jpeg": 910,
	"./Old Two.jpeg": 312,
	"./Portals.jpg": 959,
	"./Rest Up.jpg": 55,
	"./Rome.jpg": 83,
	"./Sunlight Loves Sea.jpg": 244,
	"./Zeus's Power.jpg": 786,
	"./⚡️.jpg": 656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 410;